import { initRouter } from "./router.js";
// import { initScroll } from './scroll.js'
import { initLazy } from "./lazy.js";
import { initPage } from "./page.js";
import { Header } from "Layout/header/index.js";
import { BackgroundVideo, Video } from "../video";
import { Marquee } from "../marquee";
import { Lang } from "../lang";

export let initialLoad = true;
export let video;
export let marquee;
export let backgroundVideo;

export const initApp = () => {
  // initScroll()
  initLazy();
  initPage();
  new Header();
  backgroundVideo = new BackgroundVideo(document.querySelector(`.js-background-video`));
  video = new Video(document.querySelector(`.js-fullscreen-video`));
  marquee = new Marquee(document.querySelector(`.js-marquee`));
  new Lang();
};

export const setInitialLoad = (mode) => {
  initialLoad = mode;
};
